<div class="header">
  <img class="logo" src="assets/images/logo/Covercy_logo.png" width="250px;" alt="Covercy logo" />
  <div class="welcome-strap">
    <h2 class="welcome-title">Welcome to covercy</h2>
    <p class="description">Since it’s your first visit to our portal, we have a few questions, helping us suit the best experience for you</p>
  </div>
</div>

<router-outlet></router-outlet>
